module.exports = __webpack_public_path__ + "static/img/sindex_step_num.d2b8b3a.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/index/sindex_step_num.png
// module id = sGvq
// module chunks = 1